module.exports = __webpack_public_path__ + "static/logo-cfa53b9952d6aafd329576520bdedc4d.png";